import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
// utils
import { fToNow } from 'src/utils/format-time';
// components
import Iconify from 'src/components/iconify';
import { IconButton, Tooltip } from '@mui/material';
import { useCallback, useState } from 'react';

// ----------------------------------------------------------------------

export default function NotificationItem({ notification, markNotificationAsRead }) {
  const [isRead, setIsRead] = useState(false);
  
  const renderText = (
    <ListItemText
      disableTypography
      primary={
        <Stack direction='row' alignItems='start' spacing={0.5}>
          <Typography
            sx={{
              fontSize: 14,
              mb: 1
            }}
          >
            {notification.notification.title}
          </Typography>

          {
            !notification.readAt && !isRead
            ?
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: 'info.main'
              }}
            />
            :
            <></>
          }
        </Stack>
      }
      secondary={
        <Stack
          direction="row"
          alignItems="center"
          sx={{ typography: 'caption', color: 'text.disabled' }}
          divider={
            <Box
              sx={{
                width: 2,
                height: 2,
                bgcolor: 'currentColor',
                mx: 0.5,
                borderRadius: '50%',
              }}
            />
          }
        >
          {fToNow(notification.notification.createdAt)}
        </Stack>
      }
    />
  );

  const renderUnReadBadge = !notification.readAt && !isRead && (
    <IconButton 
      onClick={() => {
        markNotificationAsRead(notification.id);
        setIsRead(true);
      }}
      sx={{
        position: 'absolute',
        right: 10,
        top: 13
      }}
      // disabled={isLoadingMarkAsRead()}
    >
      <Tooltip title="Mark as read">
        <Iconify icon="ic:baseline-message" />
      </Tooltip>
    </IconButton>
  );

  const projectAction = (
    <Stack alignItems="flex-start">
      <Box
        sx={{
          p: 1.5,
          my: 1.5,
          width: '100%',
          borderRadius: 1.5,
          color: 'text.secondary',
          bgcolor: 'background.neutral',
        }}
      >
        <Typography
          sx={{
            fontSize: 14,
            mb: 1
          }}
        >
          {notification.notification.message}
        </Typography>
      </Box>
    </Stack>
  );

  return (
    <ListItemButton
      disableRipple
      sx={{
        p: 2.5,
        alignItems: 'flex-start',
        borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
        cursor: 'auto',
        "&:hover": {
          backgroundColor: "transparent"
        }
      }}
    >
      {renderUnReadBadge}

      <Stack sx={{ flexGrow: 1 }}>
        {renderText}
        {projectAction}
      </Stack>
    </ListItemButton>
  );
}

NotificationItem.propTypes = {
  notification: PropTypes.object,
  markNotificationAsRead: PropTypes.func
};